import SectionHeading from '@/components/feature/SectionHeading';
import MovieGrid from '@/components/feature/MovieGrid';
import { getRelatedMovies } from '@/lib/movieData';
import type { Movie } from '@/types/movie';

export default function RelatedSection({ movie }: { movie: Movie }) {
  const related = getRelatedMovies(movie, 6);
  if (!related.length) return null;

  return (
    <section className="w-full px-4 md:px-8 py-12 md:py-16 bg-background-100">
      <SectionHeading
        eyebrow="猜你喜欢"
        title="相关推荐"
        description={`根据《${movie.title}》的类型、地区与题材为你智能匹配。`}
      />
      <MovieGrid movies={related} columns={6} />
    </section>
  );
}